const numberRegexp = /[-+]?([0-9]*\.[0-9]+|[0-9]+)([eE][-+]?[0-9]+)?/;
const tuples = new RegExp('^' + numberRegexp.source + '(\\s' + numberRegexp.source + '){1,}');
export const WKT_MAGIC_STRINGS = ['POINT(', 'LINESTRING(', 'POLYGON(', 'MULTIPOINT(', 'MULTILINESTRING(', 'MULTIPOLYGON(', 'GEOMETRYCOLLECTION('];
export function isWKT(input) {
  return WKT_MAGIC_STRINGS.some(magicString => input.startsWith(magicString));
}
export function parseWKT(input, options) {
  return parseWKTToGeometry(input, options);
}
function parseWKTToGeometry(input, options) {
  var _options$wkt;
  const parts = input.split(';');
  let _ = parts.pop();
  const srid = (parts.shift() || '').split('=').pop();
  const state = {
    parts,
    _,
    i: 0
  };
  const geometry = parseGeometry(state);
  return options !== null && options !== void 0 && (_options$wkt = options.wkt) !== null && _options$wkt !== void 0 && _options$wkt.crs ? addCRS(geometry, srid) : geometry;
}
function parseGeometry(state) {
  return parsePoint(state) || parseLineString(state) || parsePolygon(state) || parseMultiPoint(state) || parseMultiLineString(state) || parseMultiPolygon(state) || parseGeometryCollection(state);
}
function addCRS(obj, srid) {
  if (obj && srid !== null && srid !== void 0 && srid.match(/\d+/)) {
    const crs = {
      type: 'name',
      properties: {
        name: 'urn:ogc:def:crs:EPSG::' + srid
      }
    };
    obj.crs = crs;
  }
  return obj;
}
function parsePoint(state) {
  if (!$(/^(POINT(\sz)?)/i, state)) {
    return null;
  }
  white(state);
  if (!$(/^(\()/, state)) {
    return null;
  }
  const c = coords(state);
  if (!c) {
    return null;
  }
  white(state);
  if (!$(/^(\))/, state)) {
    return null;
  }
  return {
    type: 'Point',
    coordinates: c[0]
  };
}
function parseMultiPoint(state) {
  var _state$_, _state$_2;
  if (!$(/^(MULTIPOINT)/i, state)) {
    return null;
  }
  white(state);
  const newCoordsFormat = (_state$_ = state._) === null || _state$_ === void 0 ? void 0 : _state$_.substring(((_state$_2 = state._) === null || _state$_2 === void 0 ? void 0 : _state$_2.indexOf('(')) + 1, state._.length - 1).replace(/\(/g, '').replace(/\)/g, '');
  state._ = 'MULTIPOINT (' + newCoordsFormat + ')';
  const c = multicoords(state);
  if (!c) {
    return null;
  }
  white(state);
  return {
    type: 'MultiPoint',
    coordinates: c
  };
}
function parseLineString(state) {
  if (!$(/^(LINESTRING(\sz)?)/i, state)) {
    return null;
  }
  white(state);
  if (!$(/^(\()/, state)) {
    return null;
  }
  const c = coords(state);
  if (!c) {
    return null;
  }
  if (!$(/^(\))/, state)) {
    return null;
  }
  return {
    type: 'LineString',
    coordinates: c
  };
}
function parseMultiLineString(state) {
  if (!$(/^(MULTILINESTRING)/i, state)) return null;
  white(state);
  const c = multicoords(state);
  if (!c) {
    return null;
  }
  white(state);
  return {
    type: 'MultiLineString',
    coordinates: c
  };
}
function parsePolygon(state) {
  if (!$(/^(POLYGON(\sz)?)/i, state)) {
    return null;
  }
  white(state);
  const c = multicoords(state);
  if (!c) {
    return null;
  }
  return {
    type: 'Polygon',
    coordinates: c
  };
}
function parseMultiPolygon(state) {
  if (!$(/^(MULTIPOLYGON)/i, state)) {
    return null;
  }
  white(state);
  const c = multicoords(state);
  if (!c) {
    return null;
  }
  return {
    type: 'MultiPolygon',
    coordinates: c
  };
}
function parseGeometryCollection(state) {
  const geometries = [];
  let geometry;
  if (!$(/^(GEOMETRYCOLLECTION)/i, state)) {
    return null;
  }
  white(state);
  if (!$(/^(\()/, state)) {
    return null;
  }
  while (geometry = parseGeometry(state)) {
    geometries.push(geometry);
    white(state);
    $(/^(,)/, state);
    white(state);
  }
  if (!$(/^(\))/, state)) {
    return null;
  }
  return {
    type: 'GeometryCollection',
    geometries: geometries
  };
}
function multicoords(state) {
  white(state);
  let depth = 0;
  const rings = [];
  const stack = [rings];
  let pointer = rings;
  let elem;
  while (elem = $(/^(\()/, state) || $(/^(\))/, state) || $(/^(,)/, state) || $(tuples, state)) {
    if (elem === '(') {
      stack.push(pointer);
      pointer = [];
      stack[stack.length - 1].push(pointer);
      depth++;
    } else if (elem === ')') {
      if (pointer.length === 0) return null;
      pointer = stack.pop();
      if (!pointer) return null;
      depth--;
      if (depth === 0) break;
    } else if (elem === ',') {
      pointer = [];
      stack[stack.length - 1].push(pointer);
    } else if (!elem.split(/\s/g).some(isNaN)) {
      Array.prototype.push.apply(pointer, elem.split(/\s/g).map(parseFloat));
    } else {
      return null;
    }
    white(state);
  }
  if (depth !== 0) return null;
  return rings;
}
function coords(state) {
  const list = [];
  let item;
  let pt;
  while (pt = $(tuples, state) || $(/^(,)/, state)) {
    if (pt === ',') {
      list.push(item);
      item = [];
    } else if (!pt.split(/\s/g).some(isNaN)) {
      if (!item) item = [];
      Array.prototype.push.apply(item, pt.split(/\s/g).map(parseFloat));
    }
    white(state);
  }
  if (item) list.push(item);else return null;
  return list.length ? list : null;
}
function $(regexp, state) {
  var _state$_3;
  const match = (_state$_3 = state._) === null || _state$_3 === void 0 ? void 0 : _state$_3.substring(state.i).match(regexp);
  if (!match) return null;else {
    state.i += match[0].length;
    return match[0];
  }
}
function white(state) {
  $(/^\s*/, state);
}
//# sourceMappingURL=parse-wkt.js.map